import api from '../api';
import { store } from '../store';
import _ from 'lodash';
import dashboard_banners from './dashboard_banners';

const state = {
    header: {},
    sidebar: {},
    application: {},
    backend: {},
    online: true,
    loaded: false,
    allLoaded: false,
    content: {
        price_targets: null,
        trades: null,
        trades_per_productGroup: null,
        user: null,
        dashboard_banners: null,
        contentstreams: null,
        contentstreams_big: null,
        contentstreams_huge: null
    },
    popups: {
        product_categories_popup: {
            open: false,
            data: []
        }
    },
    sidebars: {
        cart_sidebar: {
            open: false,
            data: []
        },
        menu_sidebar: {
            open: false,
            data: []
        }
    },
    backend_sidebars: {
        backend_sidebar: {
            open: true,
            data: []
        }
    },
    data: window.meta.settings
};

const mutations = {
    set(state, data) {
        state.data = data;
    },
    setHeader(state, data) {
        state.header = data;
    },
    setApplicationType(state, data) {
        state.application.type = data;
    },
    setBackendType(state, data) {
        state.backend.type = data;
    },
    setHeaderName(state, data) {
        state.header.name = data;
    },
    setOnline(state, data) {
        state.online = data;
    },

    allLoaded(state, data) {
        state.allLoaded = data;
    },

    async togglePopup(state, data) {
        let currentOpenPopup = Object.keys(state.popups).find((key) => state.popups[key].open === true);

        // only toggle open / close if its different popup, else change data
        if (currentOpenPopup != data.name) {
            _.forEach(state.popups, (popup) => {
                popup.open = false;
                popup.data = [];
            });
            state.popups[data.name].open = !state.popups[data.name].open;
        }

        state.popups[data.name].data = data.data;
    },
    async openPopup(state, data) {
        state.popups[data.name].open = true;
        state.popups[data.name].data = data.data;
    },
    closeAllPopups(state, data) {
        if (store.getters['settings/getSidebarStateByName']('cart_sidebar')) {
            this.commit('settings/toggleSidebar', { name: 'cart_sidebar' });
        } else {
            _.forEach(state.popups, (popup) => {
                popup.open = false;
                popup.data = [];
            });
        }
    },

    async toggleSidebar(state, data) {
        let currentOpenSidebar = Object.keys(state.sidebars).find((key) => state.sidebars[key].open === true);

        // only toggle open / close if its different popup, else change data
        if (currentOpenSidebar != data.name) {
            _.forEach(state.sidebars, (sidebar) => {
                sidebar.open = false;
                sidebar.data = [];
            });
        }

        if (state.sidebars[data.name]) {
            state.sidebars[data.name].open = !state.sidebars[data.name].open;
            state.sidebars[data.name].data = data.data;
        }
    },
    async toggleBackendSidebar(state, data) {
        let currentOpenSidebar = Object.keys(state.backend_sidebars).find((key) => state.backend_sidebars[key].open === true);

        // only toggle open / close if its different popup, else change data
        if (currentOpenSidebar != data.name) {
            _.forEach(state.backend_sidebars, (sidebar) => {
                sidebar.open = false;
                sidebar.data = [];
            });
        }

        state.backend_sidebars[data.name].open = !state.backend_sidebars[data.name].open;
        state.backend_sidebars[data.name].data = data.data;
    },
    async openSidebar(state, data) {
        state.sidebars[data.name].open = true;
        state.sidebars[data.name].data = data.data;
    },
    async openBackendSidebar(state, data) {
        state.backend_sidebars[data.name].open = true;
        state.backend_sidebars[data.name].data = data.data;
    },
    async closeBackendSidebar(state, data) {
        state.backend_sidebars[data.name].open = false;
        state.backend_sidebars[data.name].data = null;
    },
    closeAllSidebars(state, data) {
        _.forEach(state.sidebars, (sidebar) => {
            sidebar.open = false;
            sidebar.data = [];
        });
    },
    contentNotLoaded(state, key) {
        state.content[key] = 'not loaded';
    },
    contentLoading(state, key) {
        state.content[key] = 'loading';
    },
    contentLoaded(state, key) {
        state.content[key] = 'loaded';
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    isMaintenanceActive: (state) => {
        return state.data?.legacy_system_block?.active === true;
    },
    getHeader: (state) => {
        return state.header;
    },
    getApplicationType: (state) => () => {
        return state.application.type;
    },
    getBackendType: (state) => () => {
        return state.backend.type;
    },
    getHeaderName: (state) => {
        return state.header.name;
    },
    getOnlineStatus: (state) => {
        return state.online;
    },
    getPopupStateByName: (state) => (name) => {
        return state.popups[name]?.open;
    },
    getPopupDataByName: (state) => (name) => {
        return state.popups[name]?.data;
    },
    getSidebarStateByName: (state) => (name) => {
        return state.sidebars[name]?.open;
    },
    getBackendSidebarStateByName: (state) => (name) => {
        return state.backend_sidebars[name]?.open;
    },
    getSidebarDataByName: (state) => (name) => {
        return state.sidebars[name]?.data;
    },
    getCurrentOpenSidebarName: (state) => (name) => {
        return Object.keys(state.sidebars).find((key) => state.sidebars[key].open === true);
    },
    getCurrentOpenBackendSidebarName: (state) => (name) => {
        return Object.keys(state.backend_sidebars).find((key) => state.backend_sidebars[key].open === true);
    },
    isAnyPopupOpen: (state) => {
        let anyOpen = false;

        _.forEach(state.popups, (popup) => {
            if (popup.open === true) {
                anyOpen = true;
            }
        });

        return anyOpen;
    },
    isAnySidebarOpen: (state) => {
        let anyOpen = false;

        _.forEach(state.sidebars, (sidebar) => {
            if (sidebar.open === true) {
                anyOpen = true;
            }
        });

        return anyOpen;
    },
    isAnyBackendSidebarOpen: (state) => {
        let anyOpen = false;

        _.forEach(state.backend_sidebars, (sidebar) => {
            if (sidebar.open === true) {
                anyOpen = true;
            }
        });

        return anyOpen;
    },
    isAllLoaded: (state) => {
        return state.allLoaded;
    },
    isContentLoaded: (state) => (key) => state.content[key] === 'loaded',
    isContentLoadedOrLoading: (state) => (key) => state.content[key] === 'loaded' || state.content[key] === 'loading'
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
};
